import { combineReducers } from "redux";
import { KOMPARASI_SHIPPER_CONTAINER_GET_SUCCESS } from "../actions/komparasiTarifAction";

const shipperNContainer = (
  state = { isLoad: false, value: [], page: {}, report: [], msg: "" },
  action
) => {
  switch (action.type) {
    case KOMPARASI_SHIPPER_CONTAINER_GET_SUCCESS:
      return {
        value: action.val,
        isLoad: action.load,
        page: action.page,
        report: action.report,
        msg: action.msg,
      };
    default:
      return state;
  }
};
const komparasiTarifReducer = combineReducers({
  shipperNContainer,
});

export default komparasiTarifReducer;
